import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApprovalsComponent } from './approvals/approvals.component';
import { ConnectionsComponent } from './connections/connections.component';
import { ConnectionEditComponent } from './connections/connection-edit.component';
import { ConnectorEditComponent } from './connections/connector-edit.component';
import { RouteRootComponent } from './route-root/route-root.component';
import { DiagramsComponent } from './diagrams/diagrams.component';
// import { FlowAdminsComponent } from './flow-admins/flow-admins.component';
import { FlowEnvironmentComponent } from './flow-environment/flow-environment.component';
import { FlowsComponent } from './flows/flows.component';
import { OAuthCallbackComponent } from './oauth-callback/oauth-callback.component';
// import { OAuthCallbackHandler } from './oauth-callback/oauth-callback.guard';
import { WelcomeComponent } from './welcome/welcome.component';
import { SubscriptionGuard } from './services/payment.service';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { SettingsComponent } from './settings/settings.component';
import { FlowSearchComponent } from './flow-search/flow-search.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { DeployComponent } from './deploy/deploy.component';
import { PlanEditComponent } from './plan-edit/plan-edit.component';
import { DebugComponent } from './debug/debug.component';
import { DebugMakersComponent } from './debug/debug-makers.component';
import { DebugStoreComponent } from './debug/debug-store.component';
import { SuccessComponent } from './success/success.component';
import { SolutionsComponent } from './solutions/solutions.component';
import { PromotionComponent } from './promotion/promotion.component';
import { ClipboardComponent } from './clipboard/clipboard.component';
import { AboutComponent } from './welcome/about.component';
import { ChangelogComponent } from './changelog/changelog.component';
import { FlowsByActionsComponent } from './flows/flows-by-actions.component';
import { TranslateComponent } from './translate/translate.component';
import { PowerAppsComponent as PowerAppsComponent } from './powerapps/powerapps.component';
import { Angulartics2Module, /* Angulartics2Mixpanel, */ Angulartics2GoogleTagManager } from 'angulartics2';
import { ZipComponent } from './zip/zip.component';
import { FailedComponent } from './msal/failed.component';
import { LoginComponent } from './msal/login.component';
import { TeamsDashboardComponent } from './teams/teams-dashboard.component';
import { TeamsSettingsComponent } from './teams/teams-settings.component';
import { TeamsRequestComponent } from './teams/teams.request.component';
import { TeamsOverviewComponent } from './teams/teams-overview.component';
import { TeamsMembersComponent } from './teams/teams-members.component';
import { SetupComponent } from './settings/setup.component';
import { FlowDiffComponent } from './flow-diff/flow-diff.component';
import { FlowsRequestComponent } from './flows/flows.request.component';
import { FlowsChildFlowsComponent } from './flows/flows.child-flows.component';
import { environment } from "../environments/environment";
import { FlowViewComponent } from './flows/flow-view.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

export const routes: Routes = [
    { path: '', component: AboutComponent /* redirectTo: '/about', pathMatch: 'full'*/ },
    { path: 'index.html', redirectTo: '/flows' },
    // { path: 'dashboard', component: DashboardComponent },
    { path: 'privacy', component: PrivacyComponent },
    // { path: 'solutions', component: SolutionsComponent },
    // { path: 'v0',
    //     component: FlowEnvironmentComponent,
    //     canActivate: [MsalGuard],
    //     // resolve: {
    //     //     'planSelected': Resolvers.SelectedPlanResolver
    //     // },
    //     children: [
    //         { path: 'runs', component: FlowsComponent },
    //         // { path: 'env', redirectTo: '/flows', pathMatch: 'full' },
    //         { path: 'flows', component: FlowsComponent },
    //         { path: 'approvals', component: ApprovalsComponent },
    //         { path: 'diagrams', component: DiagramsComponent }
    //     ]
    // },
    // { path: 'id_token', component: OAuthCallbackComponent, canActivate: [OAuthCallbackHandler] },
    { path: 'debug', component: DebugComponent },
    { path: 'debug/makers', component: DebugMakersComponent },
    { path: 'debug/store', component: DebugStoreComponent },
    //{ path: 'auth', component: MsalRedirectComponent },
    { path: 'login', component: LoginComponent },
    { path: 'login-failed', component: FailedComponent },
    { path: 'verify-email', component: VerifyEmailComponent },
    //{ path: 'token', component: MsalRedirectComponent },
    { path: 'token', component: OAuthCallbackComponent /*, canActivate: [OAuthCallbackHandler] */ },
    // { path: 'welcome', redirectTo: 'about', pathMatch: 'full' /* component: WelcomeComponent */ },
    //{ path: 'about', component: AboutComponent },
    { path: 'welcome',
        children: [
            { path: '', redirectTo: 'about', pathMatch: 'full' },
            { path: 'about', component: WelcomeComponent },
            // { path: 'analyze', component: AboutComponent  },
            // { path: 'migrate', component: AboutComponent },
            // { path: 'edit', component: AboutComponent  },

            // { path: 'privacy', component: AboutComponent  },
            // { path: 'security', component: AboutComponent  },
            { path: 'changes', component: ChangelogComponent },
            { path: '**', component: WelcomeComponent }
        ]
    },
    { path: '',
        component: RouteRootComponent,
        canActivate: [MsalGuard],
        children: [
            { path: '', redirectTo: 'flows', pathMatch: 'full' },
            { path: 'flows',
              children: [
                { path: '', data:{ fieldIncludeSolution: true }, component: FlowsComponent },
                { path: 'actions', component: FlowsByActionsComponent, canActivate: [SubscriptionGuard] },
                { path: 'request', component: FlowsRequestComponent, canActivate: [SubscriptionGuard] },
                { path: 'child-flows', component: FlowsChildFlowsComponent, canActivate: [SubscriptionGuard] },
                // Per-tab paths so deep-links and shared URLs read clearly
                // (`/flows/:env/:name/runs` instead of `…/view?tab=runs`).
                // Each route ships a `tab` in `data` that FlowViewComponent
                // reads on init. Bare `:envName/:flowName` redirects to /view
                // for backwards compat with old links.
                { path: ':envName/:flowName', redirectTo: ':envName/:flowName/view', pathMatch: 'full' },
                { path: ':envName/:flowName/view', component: FlowViewComponent, data: { tab: 'view' } },
                { path: ':envName/:flowName/runs', component: FlowViewComponent, data: { tab: 'runs' } },
                { path: ':envName/:flowName/snapshots', component: FlowViewComponent, data: { tab: 'snapshots' } },
                { path: ':envName/:flowName/json', component: FlowViewComponent, data: { tab: 'json' } },
                { path: ':envName/:flowName/diagram', component: FlowViewComponent, data: { tab: 'diagram' } },

                // Flow diff — compare two flows side-by-side. The 7-segment
                // form pins each side to a specific snapshot/version; the
                // 5-segment form defaults both to 'current'. Listed long
                // form first for clarity, but Angular disambiguates by the
                // segment count anyway.
                { path: ':envName/:flowName/:version/diff/:otherEnvName/:otherFlowName/:otherVersion',
                  component: FlowDiffComponent,
                  canActivate: [SubscriptionGuard] },
                { path: ':envName/:flowName/diff/:otherEnvName/:otherFlowName',
                  component: FlowDiffComponent,
                  canActivate: [SubscriptionGuard] }
              ]
            },
            { path: 'approvals', component: ApprovalsComponent, canActivate: [SubscriptionGuard] },
            { path: 'connections',
              children: [
                { path: '', component: ConnectionsComponent },
                { path: ':envName/:connectionName/edit', component: ConnectionEditComponent }
              ],
              canActivate: [SubscriptionGuard]
            },
            { path: 'connector/:envName/:connectorName/edit',
              component: ConnectorEditComponent,
              canActivate: [SubscriptionGuard]
            },
            { path: 'solutions', redirectTo: 'flows', pathMatch: 'full' },
            //{ path: 'solutions', component: FlowsComponent, data:{ fieldIncludeSolution: true }, canActivate: [SubscriptionGuard] },
            { path: 'admin', component: FlowsComponent, data:{ fieldIsAdmin: true }, canActivate: [SubscriptionGuard] },
//            { path: 'admin-old', component: FlowAdminsComponent, canActivate: [SubscriptionGuard] },
            { path: 'search', component: FlowSearchComponent, canActivate: [SubscriptionGuard] },
            { path: 'success', component: SuccessComponent, canActivate: [SubscriptionGuard] },
            { path: 'migrate', component: DeployComponent, canActivate: [SubscriptionGuard] },
            { path: 'migrate/plan', component: PlanEditComponent, canActivate: [SubscriptionGuard] },
            { path: 'migrate/plan/:id', component: PlanEditComponent, canActivate: [SubscriptionGuard] },
            { path: 'deploy', redirectTo: 'migrate', pathMatch: 'full' },
            { path: 'promotion', component: PromotionComponent },
            { path: 'clipboard', component: ClipboardComponent },
            { path: 'translate', component: TranslateComponent },
            { path: 'powerapps', component: PowerAppsComponent },
            { path: 'zip', component: ZipComponent, canActivate: [SubscriptionGuard] },
            { path: 'diff', component: FlowDiffComponent, canActivate: [SubscriptionGuard] },
            { path: 'settings', 
              children: [
                { path: '', component: SettingsComponent },
                { path: 'setup', component: SetupComponent }
              ]
            },
            { path: 'teams', 
              children: [
                { path: '', component: TeamsOverviewComponent },
                { path: 'monitor', component: TeamsDashboardComponent },
                { path: 'members', component: TeamsMembersComponent },
                { path: 'workspace', component: TeamsSettingsComponent },
                { path: 'settings', redirectTo: 'workspace', pathMatch: 'full' },
                { path: 'setup', redirectTo: 'workspace', pathMatch: 'full' },
                { path: 'request', component: TeamsRequestComponent },
              ]
            }
        ]
    },
    // { path: 'connections', component: ConnectionsComponent },
    // { path: 'admin', component: FlowAdminsComponent }
    { path: '**', redirectTo: '/' },

];

const webRoutes: Routes = [
    { path: '', component: AboutComponent /* redirectTo: '/about', pathMatch: 'full'*/ },
    { path: 'index.html', redirectTo: '/' },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'verify-email', component: VerifyEmailComponent },
    { path: 'debug', component: DebugComponent },
    { path: 'debug/makers', component: DebugMakersComponent },
    { path: 'debug/store', component: DebugStoreComponent },
    { path: 'welcome',
        children: [
            { path: '', redirectTo: 'about', pathMatch: 'full' },
            { path: 'about', component: WelcomeComponent },
            // { path: 'analyze', component: AboutComponent  },
            // { path: 'migrate', component: AboutComponent },
            // { path: 'edit', component: AboutComponent  },

            // { path: 'privacy', component: AboutComponent  },
            // { path: 'security', component: AboutComponent  },
            { path: 'changes', component: ChangelogComponent },
            { path: '**', component: WelcomeComponent }
        ]
    },
    { path: '**', redirectTo: '/' },
];

@NgModule({
    imports: [
        RouterModule.forRoot((environment.web ? webRoutes : routes), { enableTracing: false, useHash: false, onSameUrlNavigation: 'reload' }),
        Angulartics2Module.forRoot(),
    ],
    providers: [
        // Angulartics2Mixpanel, 
        Angulartics2GoogleTagManager
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
